import { render, staticRenderFns } from "./LoginViewLayout.vue?vue&type=template&id=a4f70ab4"
import script from "./LoginViewLayout.vue?vue&type=script&lang=js"
export * from "./LoginViewLayout.vue?vue&type=script&lang=js"
import style0 from "./LoginViewLayout.vue?vue&type=style&index=0&id=a4f70ab4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports